(() => {
  const bestSellingCollections = new Set([
    'all-in-stock',
    'under-20',
    'sale-plants',
    'new-or-updated',
  ]);

  const normalizeCollectionLink = (link) => {
    if (!(link instanceof HTMLAnchorElement)) return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (_error) {
      return;
    }

    if (url.origin !== window.location.origin) return;
    const match = url.pathname.match(/^\/collections\/([^/]+)\/?$/);
    if (!match || !bestSellingCollections.has(match[1]) || url.searchParams.has('sort_by')) return;

    url.searchParams.set('sort_by', 'best-selling');
    link.href = `${url.pathname}${url.search}${url.hash}`;
  };

  const normalizeLinksWithin = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches?.('a[href]')) normalizeCollectionLink(root);
    root.querySelectorAll?.('a[href]').forEach(normalizeCollectionLink);
  };

  normalizeLinksWithin(document.documentElement);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(normalizeLinksWithin));
  }).observe(document.body, { childList: true, subtree: true });
})();
